import { pathOr } from 'ramda';
import { TApplicationState } from '../../types/redux';
import { getUser } from './getUser';

export const getUserPhone = (state: TApplicationState) => {
  const user = getUser(state);
  const phone = pathOr(null, ['phones', 0, 'phone'], user);

  return phone ? `+${phone}` : null;
};
